import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';
import useFeature from '../featureFlags/useFeature';
import { buildFieldsToDisplay } from './useFieldDisplay';
import { useGetVisibleTabIds } from './useTabDisplay';
import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';
import { SYSTEM_MODE, usePricingModulesState } from '../../../../context/contexts/PricingModuleContext';
import { useMemo } from 'react';

export const useVisibleTabs = (fields: any) => {
    const tabIds = useMemo(() => Object.keys(fields), [fields]);
    const visibleTabIds = useGetVisibleTabIds(tabIds);
    const { pricingModulesState } = usePricingModulesState();
    const systemMode: SYSTEM_MODE = useFeature(FEATURE_FLAGS_NAMES.SystemMode) ?? SYSTEM_MODES.ON_PREM;

    const visibleFields = useMemo(() => {
        const visibleFieldsInternal = {};
        if (pricingModulesState) {
            for (const tabId of tabIds) {
                if (visibleTabIds.includes(tabId)) {
                    const tabFields = fields[tabId]?.fields || {};
                    const fieldIds = Object.keys(tabFields);
                    const fieldIdsToDisplay = buildFieldsToDisplay(fieldIds, pricingModulesState, systemMode);
                    visibleFieldsInternal[tabId] = { ...fields[tabId], fields: {} };
                    for (const fieldId of fieldIdsToDisplay) {
                        visibleFieldsInternal[tabId].fields[fieldId] = tabFields[fieldId];
                    }
                }
            }
        }
        return visibleFieldsInternal;
    }, [tabIds, visibleTabIds, fields, pricingModulesState, systemMode]);

    return visibleFields;
};
